import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import PostApi from "../../../api/PostApi";
import { getRemovedTagContent } from "../../../util/StringUtil";
import { getPostLabelName } from "../../../constant/PostClass";
import { shouldShowWriterMedal } from "../../../util/MembershipUtil";

function CardMarketingProduct() {

    const [posts, setPosts] = useState([]);
    const swiperRef = useRef(null);

    useEffect(() => {
        const loadPosts = async () => {
            try {
                const data = await PostApi.getHomeMarketingPosts(10);
                setPosts(data?.posts || []);
            } catch (error) {
                console.error("Failed to load home marketing posts:", error);
                try {
                    const fallback = await PostApi.getPosts('PT00', 1, 10);
                    setPosts(fallback?.posts || []);
                } catch (fallbackError) {
                    console.error("Failed to load fallback marketing posts:", fallbackError);
                }
            }
        };

        loadPosts();
    }, []);

    useEffect(() => {
        if (!posts.length) return undefined;

        const initSwiper = () => {
            const isPC = window.matchMedia("(min-width: 768px)").matches;

            if (swiperRef.current) {
                swiperRef.current.destroy(true, true);
                swiperRef.current = null;
            }

            if (!isPC) return;

            swiperRef.current = new window.Swiper(".vertify-box-slide .swiper-container", {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: posts.length > 1,
                navigation: {
                    nextEl: ".vertify-box-slide .swiper-button-next",
                    prevEl: ".vertify-box-slide .swiper-button-prev",
                },
            });
        };

        initSwiper();
        window.addEventListener("resize", initSwiper);

        return () => {
            window.removeEventListener("resize", initSwiper);
            if (swiperRef.current) {
                swiperRef.current.destroy(true, true);
                swiperRef.current = null;
            }
        };
    }, [posts]);

    return (
        <div class="section-area">
            <div class="section-header section-header-mo">
                <div class="section-title"><h5>마케팅 서비스</h5></div>
                <Link to={`/consulting`} title="더보기">
                    <span class="pc-only">더보기</span>
                    <i class="icon icon-arrow-right-bold"></i>
                </Link>
            </div>
            <div class="section-content">
                <div class="vertify-box-slide">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            {posts.map((post) => (
                                <div class="swiper-slide" key={post.post_id}>
                                    <Link to={"/consulting/post/detail/" + post.post_id} className="vertify-box">
                                        <div class="vertify-card-desc">
                                            <div class="vertify-card-meta">
                                                <span>{post.user_nicknm}</span>
                                                {shouldShowWriterMedal(post) && (
                                                    <i class="icon icon-medal"></i>
                                                )}

                                                <div class="vertify-card-etc">
                                                    <i class="icon icon-heart-fill"></i>
                                                    <span>{post.post_like_cnt}</span>
                                                </div>
                                            </div>
                                            <h1>{post.post_title}</h1>
                                            <p class="els3">{getRemovedTagContent(post.content)}</p>
                                            {getPostLabelName(post.post_category) && (
                                                <span class="vertify-card-badge">
                                                    {getPostLabelName(post.post_category)}
                                                </span>
                                            )}
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div class="swiper-button swiper-button-prev"></div>
                    <div class="swiper-button swiper-button-next"></div>
                </div>
            </div>
        </div>
    )
}

export default CardMarketingProduct;
